var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysErrorOutlined = function SvgSysErrorOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.807 4.64A15.21 15.21 0 0 1 16.167 0a15.836 15.836 0 0 1 11.36 4.64A14.968 14.968 0 0 1 32.167 16a15.836 15.836 0 0 1-4.64 11.36A14.97 14.97 0 0 1 16.167 32a15.836 15.836 0 0 1-11.36-4.64A14.97 14.97 0 0 1 .167 16a15.572 15.572 0 0 1 4.64-11.36Zm2.24 20.32a12.367 12.367 0 0 0 8.96 3.84 12.11 12.11 0 0 0 8.96-3.84 13.034 13.034 0 0 0 3.84-8.96 12.11 12.11 0 0 0-3.84-8.96 13.034 13.034 0 0 0-8.96-3.84 12.109 12.109 0 0 0-8.96 3.84 12.373 12.373 0 0 0 0 17.92Zm13.28-15.52 2.24 2.24-4.16 4.16 4.16 4.16-2.24 2.24-4.16-4.16-4.16 4.16L9.767 20l4.16-4.16-4.16-4.16 2.24-2.24 4.16 4.16 4.16-4.16Z"
  })));
};
export default SvgSysErrorOutlined;